import { render, staticRenderFns } from "./SfTableHeader.vue?vue&type=template&id=ce64ee40&"
import script from "./SfTableHeader.vue?vue&type=script&lang=js&"
export * from "./SfTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports